import createStore from './create-store.js';

export { createStore };
export default {
  name: 'store',
  static: { createStore },
  proto: { createStore },
};
